'use client'
/**
 * Returns a JSON.stringify replacer that safely skips circular references.
 */
const createCircularReferenceReplacer = () => {
    const seen = new WeakSet();
    return (key, value) => {
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value))
                return;
            seen.add(value);
        }
        return value;
    };
};

export { createCircularReferenceReplacer };
